import { useEffect, useState } from 'react';
import { Minus, Square, Copy, X } from 'lucide-react';
import {
  isElectron,
  isMacDesktop,
  usesCustomWindowControls,
  minimizeWindow,
  toggleMaximizeWindow,
  closeWindow,
  desktop,
} from '../utils/electron';

/**
 * WindowTitlebar — slim draggable strip hosting custom min/max/close buttons.
 *
 * Rendered only on Windows/Linux desktop builds. macOS uses its native traffic
 * lights overlaid on the sidebar (WhatsApp-style) — no strip is reserved and
 * the sidebar header itself provides the window drag region (see CSS).
 */
export default function WindowTitlebar() {
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    if (!usesCustomWindowControls || !desktop) return;
    desktop.windowIsMaximized().then(setIsMaximized).catch(() => {});
    return desktop.onWindowMaximizedChange(setIsMaximized);
  }, []);

  // macOS: no strip — native traffic lights sit over the sidebar's top
  // (WhatsApp-on-Mac). Non-Electron / web: nothing to render.
  if (!isElectron || isMacDesktop) return null;

  return (
    <div className="gt-titlebar" role="presentation">
      {usesCustomWindowControls && (
        <div className="gt-titlebar-controls">
          <button
            type="button"
            className="gt-titlebar-btn"
            aria-label="Minimize"
            title="Minimize"
            onClick={minimizeWindow}
          >
            <Minus className="gt-titlebar-icon" />
          </button>
          <button
            type="button"
            className="gt-titlebar-btn"
            aria-label={isMaximized ? 'Restore' : 'Maximize'}
            title={isMaximized ? 'Restore' : 'Maximize'}
            onClick={toggleMaximizeWindow}
          >
            {isMaximized ? (
              <Copy className="gt-titlebar-icon" />
            ) : (
              <Square className="gt-titlebar-icon" />
            )}
          </button>
          <button
            type="button"
            className="gt-titlebar-btn gt-titlebar-btn--close"
            aria-label="Close"
            title="Close"
            onClick={closeWindow}
          >
            <X className="gt-titlebar-icon" />
          </button>
        </div>
      )}
    </div>
  );
}
